var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('EditGeneticAnimalForm',{attrs:{"action":'update',"animal":_vm.animalData},on:{"form-updated":_vm.formUpdated}})],1),(_vm.dataLossWarning)?_c('DataLostWarning',{attrs:{"dialogI":_vm.dataLossWarning},on:{"closeDialog":_vm.closeWarningMessage,"saveData":_vm.closeWarningMessage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }